/*
 *   Copyright (c) 2022 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
import mitt from "mitt";
/**
 * Indicate fields of a hash that you are waiting to be populated
 * Once they're populated, emit the fulfilled event with the callback assigned
 */
export class Fulfiller {
    constructor(fields, hash) {
        this.fields = fields;
        this.hash = hash;
        this.events = mitt();
    }
    set(field, value) {
        this.hash[field] = value;
        this.check();
    }
    onFulfillment(callback) {
        this.events.on("fulfilled", callback);
        this.check();
    }
    get remaining() {
        return this.fields.length - this.check();
    }
    check() {
        let count = 0;
        for (let i = 0; i < this.fields.length; i++) {
            let field = this.fields[i];
            if (![null, undefined].includes(this.hash[field])) {
                count++;
            }
        }
        if (count === this.fields.length) {
            this.events.emit("fulfilled", this.hash);
        }
        return count;
    }
}
//# sourceMappingURL=fulfiller.js.map